var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCB221;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.6,24v-3.2c0-8.4-2-19.6-19.6-19.6c-17.6,0-19.6,11.2-19.6,19.6V24C4.1,25.3,1.2,29.8,1.2,40.4V46 c0,12.7,4.1,16.8,16.8,16.8h28c12.7,0,16.8-4.1,16.8-16.8v-5.6C62.8,29.8,59.9,25.3,51.6,24z M18,20.8c0-8.7,2.3-14,14-14 c11.7,0,14,5.4,14,14v2.8H18V20.8z M57.2,46c0,9.6-1.6,11.2-11.2,11.2H18C8.3,57.2,6.8,55.7,6.8,46v-5.6c0-9.6,1.6-11.2,11.2-11.2 h28c9.6,0,11.2,1.6,11.2,11.2V46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,39.5L43.2,39.5c-2.1,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S45.3,39.5,43.2,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,39.5L32,39.5c-2.1,0-3.8,1.7-3.8,3.7S29.9,47,32,47s3.7-1.7,3.7-3.7S34.1,39.5,32,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,39.5L20.8,39.5c-2.1,0-3.8,1.7-3.8,3.7s1.7,3.7,3.8,3.7s3.7-1.7,3.7-3.7S22.9,39.5,20.8,39.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.054a9e4aec24fa55f379af12d7b710f3.svg";
export { ForwardRef as ReactComponent };